'use client';

import { useEffect, useState } from 'react';
import { Caveat } from 'next/font/google';
import { cn } from '@/lib/utils';

const caveatLocal = Caveat({
  subsets: ['latin'],
  weight: ['600', '700'],
});

export function useIsLocalhost(): boolean {
  const [isLocalhost, setIsLocalhost] = useState(false);
  useEffect(() => {
    const host = window.location.hostname;
    setIsLocalhost(host === 'localhost' || host === '127.0.0.1');
  }, []);
  return isLocalhost;
}

type NavbarLocalhostBadgeProps = {
  className?: string;
};

/** Graffiti-style "Local" label — same Caveat treatment as "by Kindway", localhost only. */
export function NavbarLocalhostBadge({ className }: NavbarLocalhostBadgeProps) {
  const isLocalhost = useIsLocalhost();
  if (!isLocalhost) return null;

  return (
    <span
      aria-label="Local development environment"
      className={cn(
        caveatLocal.className,
        'inline-block select-none text-[1.875rem] font-semibold leading-none text-orange-500 dark:text-orange-300',
        className,
      )}
    >
      Local
    </span>
  );
}
